import React, { useState } from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import { gettext } from "web/script/modules/django-i18n";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./homepage-category-links.css";

interface Link {
    title: string;
    url: string;
}

export interface GenericType {
    title: string;
    image_url: string;
    url: string;
    links: Link[];
}

interface HomepageCategoryLinkProps {
    type: GenericType;
    isOpen: boolean;
    onClick: Function;
}

export const LINK_LIMIT = 9;

function HomepageCategoryLink({ type, isOpen, onClick }: HomepageCategoryLinkProps): JSX.Element {
    const [isExpanded, setIsExpanded] = useState(false);
    const hideLinks = type.links.length > LINK_LIMIT;
    return (
        <div className={styles.link}>
            <button
                className={styles.linkTitleContainer}
                type="button"
                onClick={(): void => onClick()}
            >
                <h4 className={styles.linkTitle}>{type.title}</h4>
                {isOpen ? (
                    <SVGIcon name={"minus"} className={styles.plusMinusIcon} />
                ) : (
                    <SVGIcon name={"plus"} className={styles.plusMinusIcon} />
                )}
            </button>
            <div
                className={classnames(styles.linkTrends, {
                    [styles.open]: isOpen,
                })}
            >
                <ul className={classnames({ [styles.hideLinks]: hideLinks && !isExpanded })}>
                    {type.links.map((link) => {
                        return (
                            <li key={link.url}>
                                <a href={link.url} className={styles.linkTrendText}>
                                    {link.title}
                                </a>
                            </li>
                        );
                    })}
                </ul>
                {hideLinks && !isExpanded && (
                    <button
                        className={styles.moreButton}
                        type="button"
                        onClick={(): void => setIsExpanded(true)}
                    >
                        {"+"}
                        {gettext("burger_menu.more_category_link") // More
                        }
                    </button>
                )}
            </div>
        </div>
    );
}

export interface HomepageCategoryLinksProps {
    genericTypes: GenericType[];
}

function HomepageCategoryLinks({ genericTypes }: HomepageCategoryLinksProps): JSX.Element {
    const id = "homepage-category-links-rail";
    const [openBlockId, setOpenBlockId] = useState<string | null>(null);

    function setOpenBlock(blockId: string): void {
        if (blockId == openBlockId) {
            // close everything
            setOpenBlockId(null);
        } else {
            // Set the new active block
            setOpenBlockId(blockId);
        }
    }

    function handleDrag(): void {
        analytics.event("rail", "drag", id);
    }
    return (
        <div className={styles.linksBase}>
            <DragRail id={id} onDragStart={handleDrag}>
                <div className={styles.linksDragRailContainer}>
                    {genericTypes.map((item) => {
                        return (
                            <HomepageCategoryLink
                                key={item.title}
                                type={item}
                                isOpen={openBlockId == item.title}
                                onClick={(): void => setOpenBlock(item.title)}
                            />
                        );
                    })}
                </div>
            </DragRail>
        </div>
    );
}

export default HomepageCategoryLinks;
